export default __webpack_public_path__ + "static/media/detailsIconHover.83669551.svg";